// extracted by mini-css-extract-plugin
export var button = "_8z-7";
export var buttonRow = "_8z-6";
export var fadeIn = "_8z-1";
export var gradient = "_8z-0";
export var panel = "_8z-2";
export var panelIn = "_8z-3";
export var subtitle = "_8z-5";
export var title = "_8z-4";